module.exports = {"pathContext":{"name":"TriggerIgnoreProvider","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"username","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-trigger-ignore-provider.json
// module id = 2072
// module chunks = 56753398129186